import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Enum } from '~/data/enums';
export const useTrialPeriodOptions = () => {
  const { t } = useTranslation();

  const trialPeriodOptions: Enum[] = useMemo(
    () => [
      { code: 'P1M', name: `1 ${t('laMonth')}` },
      { code: 'P2M', name: `2 ${t('laMonth')}` },
      { code: 'P3M', name: `3 ${t('laMonth')}` },
      { code: 'P4M', name: `4 ${t('laMonth')}` },
      { code: 'P5M', name: `5 ${t('laMonth')}` },
      { code: 'P6M', name: `6 ${t('laMonth')}` },
    ],
    [t],
  );

  const getTrialPeriodOptionName = (code: string) =>
    trialPeriodOptions.find((tpo) => tpo.code === code)?.name;

  return {
    trialPeriodOptions,
    getTrialPeriodOptionName,
  };
};
